
<list-item
  :card="item"
  :fields="['listingType', 'price']"
  v-bind="$attrs"
  v-on="$listeners"
>
  <template #image>
    <card-image :image-url="item.image" />
  </template>

  <template #info>
    <div class="item-info">
      <div class="platform-text">{{ item.platform }}</div>
      <div class="item-text">{{ item.title }}</div>

      <align class="extra-info">
        <countdown-timer
          v-if="item.endDate && item.listingType === 'Auction'"
          :end-time="item.endDate"
        />

        <span v-if="typeof item.bids === 'number'">Bids: {{ item.bids }}</span>
        <span v-if="typeof item.watchers === 'number'">Watchers: {{ item.watchers }}</span>
      </align>
    </div>
  </template>
</list-item>
